import { Translate } from 'react-redux-i18n'
import { getInnerHeight } from '../../../helpers/device'
import { Element } from '../../html/element'
import { AllPriceIncludeVATText } from '../../order/allPriceIncludeVATText'
import {
  BusinessCreditReport,
  businessCreditReportTypes,
} from '../../order/businessCreditReport'
import { ScrollComponent } from '../../scrollComponent'
import { Separator } from '../../separator'
import classes from './Content.module.scss'
import { externalLink } from '../../../../configs/externalLink'
import { useSelector } from 'react-redux'

export const Content = () => {
  const locale = useSelector((state) => state.i18n.locale)

  const onClick = () => {
    window.open(externalLink.BUSINESS_CREDIT_SERVICE_DETAILS[locale], '__blank')
  }

  const renderReportHeader = () => {
    return (
      <Element className={classes.header}>
        <div>
          <Translate value="common.popup.popupBusinessCreditReport.DESC" />
        </div>
        <Element className="mb1">
          <Element
            elementName="span"
            style={{ color: '#2C73E8', cursor: 'pointer' }}
            onClick={onClick}
          >
            <Translate value="common.popup.popupBusinessCreditReport.SERVICE_DETAIL" />
          </Element>
        </Element>
        <Separator height={1} width="100%" backgroundColor="#D5D5D5" />
      </Element>
    )
  }

  return (
    <>
      {renderReportHeader()}
      <ScrollComponent autoHeight autoHeightMax={getInnerHeight() - 200}>
        <BusinessCreditReport type={businessCreditReportTypes.POPUP} />
      </ScrollComponent>
      <div className="dFlex justifyContentEnd">
        <AllPriceIncludeVATText />
      </div>
    </>
  )
}
